import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";


import userAgreement from "./SystemGeneral/UserAgreementManagement/reducer";

import memberDefinition from "./SystemGeneral/MemberManagement/reducer";
import pageDefinition from "./SystemGeneral/PageManagement/reducer";
import roleDefinition from "./SystemGeneral/RoleManagement/reducer";
import userRoleRelation from "./SystemGeneral/UserRoleRelation/reducer";
import endPointDefinition from "./SystemGeneral/EndPointDefinition/reducer";
import pageOperation from "./SystemGeneral/PageOperation/reducer";
import UserDefinition from "./SystemGeneral/UserManagement/reducer";
import userStatusDef from "./SystemGeneral/UserStatusDef/reducer";
import testDefinition from "./SystemGeneral/TestManagement/reducer";
import dynamicPages from "./SystemGeneral/DynamicManagement/reducer";
import commonFuntionsManagement from "./SystemGeneral/CommonFunctionsManagement/reducer";

import queryBuilderReducer from "./QueryBuilder/reducer";
import merchantApplication from "./MerchantApplication/reducer";
import cityDefinition from "./CityDef/reducer"
import countryDefinition from "./Country/reducer"
import mccDefinition from "./Mcc/reducer"
import districtDefinition from "./District/reducer"
import countryStateDefinition from "./CountryState/reducer";
import companyTypeDefinition from "./CompanyTypeDef/reducer";

import paymentMethod from "./PaymentMethodDef/reducer";
import applicationStatus from "./ApplicationStatusDef/reducer";
import applicationSubStatus from "./ApplicationSubStatusDef/reducer";
import merchantAgreement from "./MerchantAgreement/reducer";
import documentType from "./DocumentType/reducer";
import memoManagement from "./MemoManagement/reducer"
import transactionProvisionSettle from "./TransactionProvisionSettle/reducer";
import domesticBankDefinition from "./DomesticBank/reducer";
import merchantPaymentFile from "./MerchantReconciliation/reducer";
import chargebackMonitoring from "./ChargebackMonitoring/reducer";

import ravenTransactionTypeDef from "./RavenTransactionTypeDef/reducer"
import payOutStatusDef from "./PayOutStatusDef/reducer"
import currencyDefinition from "./Currency/reducer";
import chargebackStatusDef from "./ChargebackStatusDef/reducer";
import transactionProvision from "./TransactionProvision/reducer";

import cardBrandDef from "./CardBrandDef/reducer";
import cardTypeDef from "./CardTypeDef/reducer";
import merchantPaymentDetail from "./MerchantPaymentDetail/reducer";
import PosEntryMode from "./PosEntryMode/reducer";
import provisionStatusDef from "./ProvisionStatusDef/reducer";
import ravenAuthorizationResponseCodeDef from "./RavenAuthorizationResponseCodeDef/reducer";
import terminalDef from "./TerminalDef/reducer";
import transactionInstallmentTypeDef from "./TransactionInstallmentTypeDef/reducer";
import transactionNetworkDef from "./TransactionNetworkDef/reducer";
import transactionSourceDef from "./TransactionSourceDef/reducer";
import userDefinitionPassword from "./SystemGeneral/UserPasswordManagement/reducer";
import doPayment from "./DoPayment/reducer";
import merchantCommissionList from "./MerchantCommissionList/reducer";
import productTypeDef from "./ProductTypeDef/reducer";
import linkPaymentStatusDef from "./LinkPaymentStatusDef/reducer"
import merchantPermission from "./MerchantPermission/reducer"
import merchantLinkPayment from "./MerchantLinkPaymentDef/reducer"
import installment from "./Installment/reducer"
import hostedPaymentPage from "./HostedPaymentPage/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  ForgetPassword,
  pageDefinition,
  roleDefinition,
  userRoleRelation,
  endPointDefinition,
  pageOperation,
  userStatusDef,
  testDefinition,
  Profile,
  memberDefinition,
  dynamicPages,
  queryBuilderReducer,
  UserDefinition,
  userAgreement,
  merchantApplication,
  mccDefinition,
  cityDefinition,
  countryDefinition,
  districtDefinition,
  countryStateDefinition,
  companyTypeDefinition,
  paymentMethod,
  applicationStatus,
  applicationSubStatus,
  merchantAgreement,
  memoManagement,
  transactionProvisionSettle,
  domesticBankDefinition,
  documentType,
  merchantPaymentFile,
  chargebackMonitoring,
  ravenTransactionTypeDef,
  payOutStatusDef,
  currencyDefinition,
  chargebackStatusDef,
  transactionProvision,
  cardBrandDef,
  cardTypeDef,
  merchantPaymentDetail,
  PosEntryMode,
  provisionStatusDef,
  ravenAuthorizationResponseCodeDef,
  terminalDef,
  transactionInstallmentTypeDef,
  transactionNetworkDef,
  transactionSourceDef,
  userDefinitionPassword,
  doPayment,
  merchantCommissionList,
  productTypeDef,
  linkPaymentStatusDef,
  merchantPermission,
  merchantLinkPayment,
  installment,
  hostedPaymentPage
});

export default rootReducer;
